import {styled} from "@mui/material/styles"
import {Button, InputBase} from "@mui/material"
import {breakpoints, FALLBACK_FONT_FAMILY} from "@next/ux-fabric"
import {Form, Container} from "../../component"

export const ClubContainer = styled(Container)`
    height: 44px;

    &:hover,
    &:focus-within {
        button {
            &:hover,
            &:active {
                background: transparent;
            }
            background: transparent;
        }
        background: ${({theme}) => theme.uxfabric.action.strong.selected.backgroundColor};
    }
`

export const ClubForm = styled(Form, {
    shouldForwardProp: prop => prop !== "xxlBreakpointEnabled",
})<{xxlBreakpointEnabled: boolean}>`
    border-radius: inherit;
    @media (min-width: ${breakpoints.values.md}px) {
        width: 15.5rem;
        height: 44px;
    }

    @media (min-width: ${breakpoints.values.lg}px) {
        width: 16.125rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        width: 18.625rem;
    }

    ${({xxlBreakpointEnabled}) =>
        xxlBreakpointEnabled &&
        `@media (min-width: ${breakpoints.values.xxl}px) {   
            width: 24.5rem;
        }`}
`

export const InputContainer = styled(InputBase)`
    width: 100%;
    letter-spacing: normal;

    input:disabled {
        background-color: #f7f7f7;
        border-radius: ${props => props.theme.uxfabric.shape.global.textField.large.borderRadius};
    }
    input {
        font-family: ${({theme}) => theme.uxfabric.component.inputText.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
        font-weight: ${({theme}) => theme.uxfabric.component.inputText.fontWeight};
        font-size: ${({theme}) => theme.uxfabric.component.inputText.fontSize};
        color: ${({theme}) => theme.uxfabric.text.primary};

        padding: 0rem 1.75rem 0rem 0.75rem;
        border: none !important;
        /* !important is used to override MVC's !important. Please refrain from using !important.  */
        box-sizing: content-box !important;

        &::-ms-clear {
            display: none;
        }

        ::placeholder {
            color: ${({theme}) => theme.uxfabric.text.secondary};
            opacity: inherit;
            text-transform: ${({theme}) => theme.uxfabric.component.inputText.textTransform};
        }

        // This needs to remain to prevent IOS autozoom when an input box has a font size lower than 16px / 1rem
        @media (max-width: ${breakpoints.values.md - 1}px) {
            font-size: 1rem;
        }
    }
`

export const SubmitButton = styled(Button)`
    && {
        width: 2.75rem;
        min-width: 2.75rem;
        height: 2.75rem;
        min-height: 2.75rem;

        border: inherit;
        border-radius: inherit;
        transition: none;

        &:hover,
        &:active {
            background: ${({theme}) => theme.uxfabric.action.strong.hovered.backgroundColor};
            border: 0;
        }
    }
`

export const ClearButton = styled("a")`
    width: 2.75rem;
    min-width: 2.75rem;
    height: 2.75rem;
    min-height: 2.75rem;
    right: 2.75rem;

    position: absolute;
    color: ${({theme}) => theme.uxfabric.text.primary};
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: ${breakpoints.values.md}px) {
        padding: 0.4375rem 0.5rem;
        width: 2.25rem;
        min-width: 2.25rem;
        height: 2.625rem;
        min-height: 2.625rem;
        right: 2.25rem;
    }
`
